export const enLanguage = {
	close: 'Close',
	dataIterator: {
		noResultsText: 'No matching records found',
		loadingText: 'Loading items...',
	},
	dataTable: {
		itemsPerPageText: 'Rows per page:',
		ariaLabel: {
			sortDescending: ': Sorted descending. Activate to remove sorting.',
			sortAscending: ': Sorted ascending. Activate to sort descending.',
			sortNone: ': Not sorted. Activate to sort ascending.',
		},
		sortBy: 'Sort by',
	},
	dataFooter: {
		itemsPerPageText: 'Items per page:',
		itemsPerPageAll: 'All',
		nextPage: 'Next page',
		prevPage: 'Previous page',
		firstPage: 'First page',
		lastPage: 'Last page',
		pageText: '{0}-{1} of {2}',
	},
	datePicker: {
		itemsSelected: '{0} selected',
	},
	noDataText: 'No data available',
	carousel: {
		prev: 'Previous visual',
		next: 'Next visual',
		ariaLabel: {
			delimiter: 'Carousel slide {0} of {1}',
		},
	},
	calendar: {
		moreEvents: '{0} more',
	},
	fileInput: {
		counter: '{0} files',
		counterSize: '{0} files ({1} in total)',
	},
	timePicker: {
		am: 'AM',
		pm: 'PM',
	},
	common: {
		project: 'ICLOUD',
		page: 'page',
		bindBtn:'Bind',
		editBtn:'Edit',
		deleteBtn: 'Delete',
		noData: 'No Data',
		action: 'Action',
		sureBtn: 'Sure',
		returnBtn: 'Return',
		cancelBtn: 'Cancel',
		saveBtn: 'Save',
		sureLabel: 'OK',
		cancalLabel: 'Cancel',
		tip: 'Tips',
		loginOut: 'Logout',
		login: 'Login',
		register: 'Register',
		role: 'No Role',
		close: 'Close',
		next: 'Next',
		pre: 'Previous',
		pass: 'Pass',
		pickTimeRange: 'Select time period',
		export: 'Export',
		loading:'Loading',
		reload:'Restart',
		search:'Search',
		look:'Look',
		success:'Sucess',
		errors:'Fail',
	},
	menu: {
		dashboard: 'Dashboard',
		search:'Search',
	},
	login: {
		nullTip: 'Username or password is required',
		forget: 'Forgot your password?',
		input: 'Please enter user name and account number',
		person: 'Personal Center',
		info: 'Personal information',
		edit: 'Editing',
		edit_txt: 'Improve your profile',
	},
	bindPermission: {
		role: 'Add roles',
		permission: 'Binding authority',
		account: 'Add account',
		building: 'Add group',
		set: 'Configure users',
	},
	permission: {
		deleteTheme: 'Permission list deleted',
		add: 'Add permission',
		table: {
			theme: 'Permission list',
			id: 'ID',
			name: 'Route',
			zh: 'Name',
			icon: 'Icon',
			is_menu: 'Menu',
			created_at: 'Created_at',
			updated_at: 'Updated_at',
			status: 'Status',
			height: 'Height',
			pid: 'Subordinate ID',
			description: 'description',
		},
		rule: {
			name: 'Route is required',
			zh: 'Name is required',
			icon: 'Icon is required',
			pid: 'Dependent ID is required',
			height: 'Height is required',
			menu: 'Menu item is required',
		},
		deleteTip: "Are you sure you want to delete this permission!",
		deleteTipForce: 'Are you sure you want to delete this permission, Once it is deleted, it cannot be restored?',
		deleteTipStore: 'Are you sure you want to restore this permission?',
	},
	building: {
		deleteTheme: 'Deleted group list',
		table: {
			theme: 'Group list',
			id: 'ID',
			name: 'Name',
			desc: 'description',
			created_at: 'created_at',
			updated_at: 'updated_at',
		},
		update: 'Update group',
		add: 'Add group',
		rule: {
			name: 'Name is required'
		},
		deleteTip: "Are you sure to delete the group? Once deleted, it cannot be recovered!",
		warning: 'Group information is required',
	},
	shop: {
		warning: 'Only one group can be selected for binding',
		table: {
			theme: 'List of stores',
			id: 'ID',
			name: 'Name',
			province: 'Province',
			city: 'City',
			area: 'Area',
			address: 'Address',
			created_at: 'Created_at',
			updated_at: 'Updated_at',
		},
		update: 'Update stores',
		add: 'Add stores',
		rule: {
			name: 'Name is required'
		},
		deleteTip: 'Whether to delete the store, Once deleted, it cannot be recovered!'
	},
	user: {
		user: 'User',
		userTip: 'Improve role information',
		userTipAdd: 'Add role information',
		buttonAdd: 'Add user',
		buttonUpdate: 'Modify user',
		buttonUse: 'Is it enabled?',
		theme: 'Soft delete user list',
		table: {
			theme: 'User list',
			name: 'Username',
			uuid: 'Uuid',
			nickname: 'Nickname',
			password: 'Password',
			repassword: 'Repeat password',
			phone: 'Phone',
			email: 'Email',
			create_at: 'created_at',
			update_at: 'updated_at',
			delete_at: 'deleted_at',
			info: 'Other information',
			tip: '(Modifiable)',
			tip1: '(Must fill)'
		},
		rule: {
			name: 'Category name is required',
			nickname: 'Nickname is required',
			password: 'Password is required',
			phone: 'Phone is required',
			email: 'Email is required',
			info: 'Information is required',
		},
		tips: 'Please bind the user',
		permissionRole: 'All role types',
		permissionBuilding: 'All building types',
		roleTip: 'Please select a role to bind. It is required',
		buildingTip: 'Please select a building for binding, is required',
		warningTip: 'Role or building is required',
		deleteTip: 'Are you sure you want to delete this user',
		deleteTipForce: 'Are you sure you want to delete this user. Once deleted, it cannot be recovered?',
		deleteTipStore: 'Are you sure you want to restore this user?',
		warning: 'User information is required',
	},
	role: {
		txt: 'all',
		userTo: 'Configuration permission Click ',
		theme: 'Soft delete role list',
		peimission: 'Peimissions',
		permission_txt: 'Please select your permission',
		table: {
			theme: 'Role list',
			name: 'Role Name',
			type: 'Type',
			description: 'Description',
			create_at: 'Create Time',
			update_at: 'Update Time',
			delete_at: 'Delete Time',
			action: 'Action',
			info: 'Info',
			tip: '(Modifiable)',
			tip1: '(Required)'
		},
		rule: {
			type: 'Type is required',
			name: 'Name is required',
			descript: 'Descriptions is required',
			info: 'Info is required'
		},
		role: 'Role',
		roleTip: 'Improve role information',
		roleTipAdd: 'Add role information',
		buttonAdd: 'Add',
		buttonUpdate: 'Update',
		buttonDelete: 'Delete',
		buttonLock: 'Lock',
		tips: 'Please select permissions for this role',
		deleteTip: 'Are you sure you want to delete this user',
		deleteTipForce: 'Are you sure you want to delete this role. Once deleted, it cannot be recovered?',
		deleteTipStore: 'Are you sure you want to restore this role?',
		warning: 'Role information is required',
	},
	bandwidth:{
		tableName: "Bandwidth list",
		wg: 'Gateway',
		date: 'Date',
		action: 'Action',
		editItem: 'Edit',
		chartTitle: 'Trend map',
		pickWg: 'Select gateway',
	},
	server:{
		titleServer:'Server management',
		title:'Authentication library information',
		titleBase:'Authentication library',
		titleDeleteAttribute:'Delete attribute',
		titleAddAttribute:'Add attribute',
		table:{
			addServer:'Add radius',
			add:'Add authentication',
			addBase:'Add certification Library',
			name:'Name of certification base',
			sessionTime:'Length of Internet access(s)',
			idleTime:'Free online time',
			filterId:'User group or ACLID',
			aruba:'Role definition',
			password:'Password',
			username:'Username',
			created_at:'Creation time',
			updated_at:'Update time',
			radiusName:'Name',
			radiusAddress:'Address',
			radiusStatus:'Status',
			radiusPort1:'Charging Por',
			radiusPort2:'Accounting Port',
		},
		btn:{
			addRadius:'Add radius address',
			add:'Add authentication',
			edit:'Edit authentication',
			delete:'Confirm deletion',
			addBase:'Add authentication library',
			editBase:'Edit authentication library',
			restart:'Restart',
			save:'Save',
			close:'Close',
			open:'Open',
		},
		label:{
			baselist:'Authentication library list',
			base:'Please select authentication library',
			username:'Username',
			password:'Password',
			charging:'Radius Charging Port',
			accounting:'Radius Accounting Port',
			name:'Name',
			sessionTime:'Length of Internet access(s)',
			idleTime:'Free online time',
			filterId:'User group or ACLID',
			aruba:'Role definition',
			port:'Please Input the port number',
			attr:'Radius attribute',
			attrData:'Radius data',
		},
		dialogs:{
			delete:'Confirm to delete information',
			titleDeleteAttribute:'Confirm to delete attribute',
		},
		rule:{
			name:'Name is required',
			username:'Username is required',
			password:'Password is required',
			radiusName:'Radius name is required',
			radiusAddress:'Radius address is required',
			port:'Port is required',
			shop:'Shop is required',
			group:'Group is required',
			attr:'Attribute is required',
			attrValue:'Attribute value  is required',
		},
		placeholder:{
			name:'Please Input the authentication library name',
			radiusAddress:'Please Input the radius address',
			radiusName:'Please Input the radius name',
			radiusport:'Please Input the port',
			attr:'Please Input the Attribute',
		}
	},
	client:{
		title:'Client information management',
		table:{
			add:'Add Client',
			nasid:'NASID',
			psk:'PSK',
			base:'Authentication library',
			case:'Scene',
		},
		btn:{
			add:'Add authentication',
			edit:'Edit authentication',
			delete:'Confirm deletion',
		},
		dialogs:{
			delete:'Confirm to delete information?',
		},
		rule:{
			nasid:'NASID is required',
			psk:'PSK is required',
			base:'Authentication library required',
			case:'Scene is required',
			group:'Group is required',
		},
		label:{
			nasid:'NASID',
			psk:'PSK',
			base:'Authentication library',
			case:'Scene',
			group:'Group',
			
		},
		placeholder:{
			nasid:'Input nasid',
			psk:'Input psk',
			base:'Select authentication library',
			case:'Select a place',
			group:'Select a Group',
		}
	},
	device:{
		title:'List of network security devices',
		selectTitle:'Select filter criteria',
		btn:{
			exports:'Export',
			inputs:'Import',
			edit:'Modify device information',
			delete:'Confirm deletion',
		},
		txt:{
			null:'0',
			type1:'Single audit device',
			type2:'Single sniffer device',
			type3:'Audit sniffer device',
			baseInfoStatus0:'Unreported',
			baseInfoStatus1:'Reporting',
			baseInfoStatus2:'Reported',
			big:'>0',
			status1:'Normal',
			status2:'Abnormal'
		},
		placeholder:{
			area:'Select area',
			company:'Select a group',
			place:'Select a place',
			name:'Select a name',
			type:'Select a type',
			status1:'Select report status',
			status2:'Select real identity status',
			status3:'Select virtual identity status',
			status4:'Select sniff status',
			status5:'Select uplink platform status',
		},
		rule:{
			name:'Name is required',
			mac:'Mac is required',
			type:'Type is required',
			group:'Group is required',
			shop:'Shop is required'
		},
		label:{
			pro:'Province',
			city:'City',
			area:'Area',
			company:'Group',
			place:'Place',
			name:'Name',
			type:'Type',
			status1:'Report status',
			status2:'Real identity status',
			status3:'Virtual identity status',
			status4:'Sniff status',
			status5:'Uplink platform status',
		},
		table:{
			add:'Add device',
			id:'ID',
			pro:'Province',
			city:'City',
			area:'Area',
			company:'Group',
			place:'Place',
			name:'Name',
			type:'Type',
			status1:'Report status',
			status2:'Real identity status',
			status3:'Virtual identity status',
			status4:'Sniff status',
			status5:'Uplink platform status',
			role1:'Real identity',
			upTime:'On-line time',
			mac:'Mac',
			apmac:'Apmac',
			role2:'Virtual identity',
			roleType:'Virtual identity type',
		}
	},
	gateway:{
		implementOk:'Executed',
		implementCancel:'Unexecuted',
		statusUp:'On-line',
		statusDown:'Off-line',
		equipment:'Gateway device',
		equipment2:'Network safety equipment',
		title_waiting:"List of devices to be bound",
		title:'Device list',
		title_wait:'List of devices to be bound',
		title_instructions:'List of historical instruction details',
		selecTitle:'Select device list criteria',
		table:{
			pro:'Province',
			city:'City',
			area:'Area',
			company:'Group',
			place:'Place',
			name:'Name',
			status:'Status',
			license:'To grant authorization',
			deviceId:'Serial number',
			os:'System version',
			uptime:'Turn on time',
			version:'Gateway version',
			instructions:'Instructions',
			mac:'Mac',
		},
		tableExpand:{
			powerOk:'Authorized',
			powerCancel:'Unauthorized',
			progress:'Progress',
			msg:'Information',
			abnormal:'Abnormal information',
			memory:'Memory ratio',
			cpu:'Usage situation',
			disk:'Disk mount information',
			diskname:'Disk name',
			diskposition:'Position',
			disktype:'Type',
			availableSpace:'Available space',
			useSpace:'Use space',
			bandwidth:'Bandwidth',
			bandname:'Interface name',
			bandpocketS:'Sending packets',
			bandnumberS:'Bytes sent',
			bandpocketR:'Number of packets received',
			bandnumberR:'Bytes received',
			listenPort:'Monitor port information',
			listenProgress:'Process information',
			listenPath:'Process path',
			listenName:'Process file name',
			listenCmds:'Process parameters',
			listenType:'Listening port type',
			listenPortN:'Monitor port',
			dhcpLeases:'List of assigned clients',
			dhcpName:'Name',
			dhcpTime:'Time',
			dhcpInterface:'Interface state',
			command:'Command',
			pid:'Pid',
		},
		label:{
			areaPro:'Province',
			areaCity:'City',
			areaArea:'Area',
			company:'Group',
			place:'Place',
			name:'Name',
			type:'Type',
			status:'Status',
		},
		rule:{
			name:'Name is required',
			gateway:'The number of gateways is required',
			ins:'Instructions is required',
			device:'Devices is required',
		},
		btn:{
			add_ins:'Add instruction',
			add:'Add gateway device',
			exports:'Export',
			inputs:'Import',
			editTheme:'Bind',
			edit:'Modify',
			delete:'Confirm deletion',
			join:'Join',
			login:'Remote login',
			look:'View details',
			remote:'Add remote',
			used:'Implement',
			go:'Gateway',
		},
		placeholder:{
			areaPro:'Select province',
			areaCity:'Select city',
			areaArea:'Select area',
			company:'Input Group',
			place:'Input place',
			name:'Input name',
			type:'Input Type',
			status:'Input status',
            inputname:'Input name',
            ip:'Input Ip'
		},
		instructions:{
			ins:'Instruction',
			name:'Instruction name',
			placeholder:'Input instruction',
			equipment:'Gateway device',
			status:'Status',
			time:'Time',
			step1:'Name of step 1',
			step2:'Name of step 2',
			step3:'Name of step 3',
			pre:'Previous',
			next:'Next',
		}
	},
}